import  api  from './api';

export const getTimeline = async (idTimesheet) => {
    let timeline = null;
    try {
        const response = await api.get(`Timesheet/${idTimesheet}/timeline`);
        timeline = response.data.data;
    } catch (err) {}
    return timeline;
}